import { Navigate, useParams } from 'react-router-dom';

export default function InspectorMessagingRedirectPage() {
  const { id } = useParams();
  if (id) {
    return <Navigate to={`/inspector/messaging/inbox/${id}`} />;
  }
  return <Navigate to={'/inspector/messaging/inbox'} />;
}
